import { CenterEnrollmentAgeCompliance } from '../../lib/types/models/center/center-age-compliance'
import { encodeNestedObject } from '../../lib/utils/functions/misc.functions'
import { API, constructApiUrl } from '../apis.config'
import { restApiClient } from '../rest-api-client'

export function getCenterEnrollmentsAgeCompliance(centerId: number, enrollmentIds: number[]) {
  return restApiClient
    .url(
      encodeNestedObject(
        constructApiUrl(API.centers.getEnrollmentsAgeCompliance.url, { id: centerId }),
        { enrollmentIds }
      )
    )
    .get<CenterEnrollmentAgeCompliance[]>()
}
